/**
 * @generated SignedSource<<74aa06f0b0391a6303b5f51a2a53e88b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Row73BadPattern$data = {
  readonly id: string;
  readonly isHighlightedIssueRow: boolean | null | undefined;
  readonly issueId: string;
  readonly " $fragmentSpreads": FragmentRefs<"IssueRow747BadPattern">;
  readonly " $fragmentType": "Row73BadPattern";
};
export type Row73BadPattern$key = {
  readonly " $data"?: Row73BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"Row73BadPattern">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isRemoteLinkedIssuesEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "Row73BadPattern",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isDensityFull",
          "variableName": "isDensityFull"
        },
        {
          "kind": "Variable",
          "name": "isRemoteLinkedIssuesEnabled",
          "variableName": "isRemoteLinkedIssuesEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "IssueRow747BadPattern"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "issueId"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isHighlightedIssueRow"
        }
      ]
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "485643583029442b6439d01d6a70047c";

export default node;
